/**
 * This class is used to create an error object that contains additional information for debugging.
 */
export default class EnrichedError extends Error {
  status: number;
  userMessage: string;
  serverMessage: string;
  clientMessage: string;
  url: string;

  /**
   * @param status HTTP status code.
   * @param userMessage Operator-facing error message.
   * @param serverMessage Developer-facing server-defined error message.
   * @param clientMessage Developer-facing client-defined error message.
   * @param url URL for the API endpoint that threw the error.
   */
  constructor(
    status: number,
    userMessage: string,
    serverMessage: string,
    clientMessage: string,
    url: string,
  ) {
    super(clientMessage);
    this.status = status;
    this.userMessage = userMessage;
    this.serverMessage = serverMessage;
    this.clientMessage = clientMessage;
    this.url = url;
  }
}
